import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  /**
   * Move the active retailer of this session to the given one.
   *
   * The switch touches only the token that makes this request, so another device stays where it
   * was. The response is the regular auth user payload, already describing the new retailer.
   */
  switchRetailer(retailerId) {
    return RetailerApiClient.post(`memberships/${retailerId}/switch`, {})
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  }
}
